var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
export function mixin(target, source) {
  var targetCopy = target;
  Object.keys(source).forEach(function (item) {
    if ({}.hasOwnProperty.call(source, item)) {
      targetCopy[item] = source[item];
    }
  });
  return targetCopy;
}
export function throttle(func, wait) {
  if (wait === void 0) {
    wait = 100;
  }
  var timeout;
  var elapsed;
  var lastRunTime = Date.now();
  return function none() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = this;
    clearTimeout(timeout);
    elapsed = Date.now() - lastRunTime;
    function later() {
      lastRunTime = Date.now();
      timeout = null;
      func.apply(_this, args);
    }
    if (elapsed > wait) {
      later();
    } else {
      timeout = setTimeout(later, wait - elapsed);
    }
  };
}
export function isNull(obj) {
  return Object.prototype.toString.call(obj).replace(/\[object[\s]/, '').replace(']', '').toLowerCase() === 'null';
}
export function RGBToHex(color) {
  var _a = __read(color.match(/\d+/g), 3),
    r = _a[0],
    g = _a[1],
    b = _a[2];
  r = Number(r).toString(16);
  g = Number(g).toString(16);
  b = Number(b).toString(16);
  if (r.length === 1) r = '0' + r;
  if (g.length === 1) g = '0' + g;
  if (b.length === 1) b = '0' + b;
  return '#' + r.toLocaleUpperCase() + g.toLocaleUpperCase() + b.toLocaleUpperCase();
}
export function intersect(a, b) {
  return a.filter(function (v) {
    return b.includes(v);
  });
}
export default null;